module.exports = __webpack_public_path__ + "static/media/juan.7f9b4de7.png";